import { api, handleResponse } from "@/api/config";

export const leadService = {
  getAll: async (params) => {
    const res = await api.get("/leads", { params });
    return handleResponse(res);
  },

  getById: async (id) => {
    const res = await api.get(`/leads/${id}`);
    return handleResponse(res);
  },

  create: async (data) => {
    const res = await api.post("/leads", data);
    return handleResponse(res);
  },

  update: async (id, data) => {
    const res = await api.put(`/leads/${id}`, data);
    return handleResponse(res);
  },

  delete: async (id) => {
    const res = await api.delete(`/leads/${id}`);
    return handleResponse(res);
  },

  // ✅ CORRECT METHOD (PATCH)
  updateStatus: async (id, status) => {
    const res = await api.patch(`/leads/${id}/status`, { status });
    return handleResponse(res);
  },

  assign: async (id, assignedTo) => {
    const res = await api.put(`/leads/${id}/assign`, { assignedTo });
    return handleResponse(res);
  },

  import: async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const res = await api.post("/leads/import", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return handleResponse(res);
  },

  getAnalytics: async () => {
    const res = await api.get("/analytics/leads");
    return handleResponse(res);
  },

  // ✅ FIXED PATH
  getStatusHistory: async (leadId) => {
    const res = await api.get(`/leads/${leadId}/status-history`);
    return handleResponse(res);
  },

  // ❌ REMOVED changeStatus (deprecated / duplicate)

  // ✅ FIXED PATH
  getStatusCounts: async () => {
    const res = await api.get(`/leads/status-counts`);
    return handleResponse(res);
  },
};

export default leadService;
